<template>
    <v-container id="gestioncuota-ivt">
      <v-row class="text-center">
        <v-col cols="12">
          <v-card class="alineacentro DatosMatriculado">
            <v-card-title class="DatosMatriculado">
              <v-row class="text-center">
                <v-col cols="12">
                  <v-card
                    dark
                    color="success"
                    class="alineacentro DatosMatriculado"
                  >
                    <strong>GESTIÓN DE CUOTAS</strong>
                  </v-card>
                </v-col>
              </v-row>
            </v-card-title>
            <v-card-text>
              <v-row dense>
                <v-col>
                  <v-spacer />
                </v-col>
              </v-row>
              <v-row class="text-center">
                <v-col cols="12" md="6" lg="6">
                  <v-select
                    v-model="filtros.idcarrera"
                    :items="listacarreras"
                    label="Carrera"
                    item-text="carrera"
                    item-value="idcarrera"
                    height="20px"
                    v-on:change="ActualizaGrilla()"
                  />
                </v-col>
                <v-col cols="12" md="2" lg="2">
                  <v-select
                    v-model="filtros.anio"
                    :items="listaanios"
                    label="Año"
                    item-text="anio"
                    item-value="anio"
                    height="20px"
                    v-on:change="ActualizaGrilla()"
                  />
                </v-col>
                <v-col cols="12" md="4" lg="4">
                  <v-btn
                    class="ma-2"
                    dark
                    x-small
                    color="primary"
                    title="Listar"
                    @click="ActualizaGrilla"
                    :disabled="!permisolectura"
                  >
                    <v-icon dark> mdi-magnify </v-icon>
                  </v-btn>
                  <v-btn
                    class="ma-2"
                    dark
                    x-small
                    color="primary"
                    title="Nueva Cuota"
                    @click="Nueva"
                    :disabled="!permisoescritura"
                  >
                    <v-icon dark> mdi-new-box </v-icon>
                  </v-btn>
                </v-col>
              </v-row>
              <v-row class="text-center">
                <v-col cols="12">
                  <v-data-table
                    :headers="columnas"
                    :items="lista"
                    :items-per-page="10"
                    :footer-props="{
                        'items-per-page-text': 'Filas por Página:',
                        'items-per-page-all-text': 'Todos',
                    }"
                    item-key="idcuota"
                    class="elevation-1"
                    dense
                    no-data-text="Sin Registros"
                    multi-sort
                  >
                    <template v-slot:item.actions="{ item }">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            small
                            @click="Editar(item)"
                            v-bind="attrs"
                            v-on="on"
                            :disabled="!item.permiteeditar"
                          >
                            mdi-pencil
                          </v-icon>
                        </template>
                        <span>Editar Cuota</span>
                      </v-tooltip>
                      &nbsp;&nbsp;
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            small
                            @click="Anular(item)"
                            v-bind="attrs"
                            v-on="on"
                            :disabled="!item.permiteanular"
                          >
                            mdi-delete-circle
                          </v-icon>
                        </template>
                        <span>Anular Cuota</span>
                      </v-tooltip>
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-dialog v-model="dialogmensaje" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">
          {{ mensajetitulo }}
        </v-card-title>
        <v-card-text>
          {{ mensajecuerpo }}
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="green darken-1"
            text
            @click="
              dialogmensaje = false;
              if (mensajehome === true) {
                $router.push('Home');
              }
            "
          >
            Aceptar
          </v-btn>
        </v-card-actions>
      </v-card>
      </v-dialog>
      <v-dialog v-model="loading" full-width>
      <v-container
        fluid
        class="full-height"
        style="background-color: rgba(255, 255, 255, 0.5)"
      >
        <v-row
          align="center"
          justify="center"
          style="height: 100vh"
          no-gutters
          dense
        >
          <v-col class="elementocentrado">
            <v-progress-circular indeterminate color="primary" />
          </v-col>
        </v-row>
      </v-container>
      </v-dialog>
      <v-dialog v-model="dialognuevacuota" fullscreen>
        <v-card>
          <v-card-title class="headline">
            Nueva Cuota
          </v-card-title>
          <v-card-actions>
            <v-row>
              <v-col cols="12" class="alineaderecha">
                <v-btn color="green darken-1" text @click="GrabarCuota">
                  Grabar
                </v-btn>
                <v-btn
                  color="red darken-1"
                  text
                  @click="dialognuevacuota = false"
                >
                  Cancelar
                </v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
          <v-card-text>
            <v-row row wrap>
              <v-col cols="12" md="3" lg="3">
                <v-select
                    v-model="edited.idtipocuota"
                    :items="listatiposcuota"
                    label="Tipo"
                    item-text="nombre"
                    item-value="idtipocuota"
                    class="ocupa90"
                    height="20px"
                />
              </v-col>
              <v-col cols="12" md="9" lg="9">
                <v-select
                    v-model="edited.idcarrera"
                    :items="listacarreras"
                    label="Carrera"
                    item-text="carrera"
                    item-value="idcarrera"
                    class="ocupa90"
                    height="20px"
                />
              </v-col>
            </v-row>
            <v-row row wrap>
              <v-col cols="12" md="3" lg="3">
                <v-select
                    v-model="edited.anio"
                    :items="listaanios"
                    label="Año"
                    item-text="anio"
                    item-value="anio"
                    class="ocupa90"
                    height="20px"
                />
              </v-col>
              <v-col cols="12" md="3" lg="3">
                <v-select
                    v-model="edited.nrocuota"
                    :items="listanrocuota"
                    label="N° Cuota"
                    item-text="nro"
                    item-value="nro"
                    class="ocupa90"
                    height="20px"
                />
              </v-col>
              <v-col cols="12" md="6" lg="6">
                <v-text-field
                    v-model="edited.descripcion"
                    label="Descripción"
                    height="20px"
                />
              </v-col>
            </v-row>
            <!-- <v-row row wrap>
              <v-col cols="12">
                <v-select
                    v-model="edited.idestado"
                    :items="listaestados"
                    label="Estado"
                    item-text="nombre"
                    item-value="idestado"
                    class="ocupa90"
                    height="20px"
                />
              </v-col>
            </v-row> -->
            <v-row row wrap>
              <v-col cols="12">
                <br />
                <v-card flat height="auto" color="grey" class="alineacentro">
                  <v-card-text class="titulocardchico TituloGrilla2">
                    <strong>VENCIMIENTOS</strong>
                  </v-card-text>
                  <v-card-text>
                    <v-row row wrap>
                      <v-col cols="12" md="2" lg="2" class="alineaizquierda">
                        <v-chip>1° Vencimiento:</v-chip>
                      </v-col>
                      <v-col cols="12" md="4" lg="4" class="alineaizquierda">
                        <v-menu
                            v-model="menufvenc1"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                                v-model="fechalocalfvenc1"
                                label="Fecha"
                                prepend-icon="mdi-calendar"
                                v-bind="attrs"
                                v-on="on"
                                class="ocupa90"
                                height="20px"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="vencimiento.fecha1"
                            @input="menufvenc1 = false"
                          ></v-date-picker>
                        </v-menu>
                      </v-col>
                      <v-col cols="12" md="6" lg="6" class="alineaizquierda">
                        <v-text-field
                          v-model="vencimiento.monto1"
                          label="Monto"
                          class="ocupa90"
                          height="20px"
                          type="number"
                        />
                      </v-col>
                    </v-row>
                    <v-row row wrap>
                      <v-col cols="12" md="2" lg="2" class="alineaizquierda">
                        <v-chip>2° Vencimiento:</v-chip>
                      </v-col>
                      <v-col cols="12" md="4" lg="4" class="alineaizquierda">
                        <v-menu
                            v-model="menufvenc2"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                                v-model="fechalocalfvenc2"
                                label="Fecha"
                                prepend-icon="mdi-calendar"
                                v-bind="attrs"
                                v-on="on"
                                class="ocupa90"
                                height="20px"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="vencimiento.fecha2"
                            @input="menufvenc2 = false"
                          ></v-date-picker>
                        </v-menu>
                      </v-col>
                      <v-col cols="12" md="6" lg="6" class="alineaizquierda">
                        <v-text-field
                          v-model="vencimiento.monto2"
                          label="Monto"
                          class="ocupa90"
                          height="20px"
                          type="number"
                        />
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-dialog>
      <ConfirmDlg ref="confirm" />
    </v-container>
</template>
<script>
import axios from "@/axios";
import ConfirmDlg from "../Confirm.vue";
export default {
  name: "gestioncuota",
  components: {
    ConfirmDlg: ConfirmDlg
  },
  data() {
    return {
      loading: false,
      usuario: '',
      permisolectura: false,
      permisoescritura: false,
      idrol: 0,
      roles: [],
      nromodulo: 12,
      dialogmensaje: false,
      mensajetitulo: '',
      mensajecuerpo: '',
      mensajehome: false,
      listacarreras: [],
      listaanios: [],
      filtros: {
        idcarrera: 1,
        anio: 0,
        usuario: ''
      },
      columnas: [
        {
          text: "Op.",
          value: "actions",
          sortable: false,
          width: 80,
        },
        {
          text: "ID",
          align: "center",
          sortable: true,
          value: "idcuota",
          width: 70,
        },
        {
          text: "Año",
          align: "center",
          sortable: true,
          value: "anio",
          width: 80,
        },
        {
          text: "N° Cuota",
          align: "center",
          sortable: true,
          value: "nrocuota",
          width: 80,
        },
        {
          text: "Descripción",
          align: "center",
          sortable: true,
          value: "descripcion",
          width: 140,
        },
        {
          text: "Carrera",
          align: "center",
          sortable: true,
          value: "carrera",
          width: 150,
        },
        {
          text: "Estado",
          align: "center",
          sortable: true,
          value: "estado",
          width: 100,
        },
        {
          text: "Tipo",
          align: "center",
          sortable: true,
          value: "tipocuota",
          width: 110,
        },
        /* {
          text: "Monto",
          align: "center",
          sortable: true,
          value: "monto",
          width: 100,
        }, */
        {
          text: "Venc 1",
          align: "center",
          sortable: true,
          value: "venc1",
          width: 100,
        },
        {
          text: "Monto 1",
          align: "center",
          sortable: true,
          value: "monto1",
          width: 110,
        },
        {
          text: "Venc 2",
          align: "center",
          sortable: true,
          value: "venc2",
          width: 100,
        },
        {
          text: "Monto 2",
          align: "center",
          sortable: true,
          value: "monto2",
          width: 110,
        },
        {
          text: "Usuario",
          align: "center",
          sortable: true,
          value: "usuario",
          width: 110,
        },
        {
          text: "Fecha",
          align: "center",
          sortable: true,
          value: "fechahoraregistro",
          width: 120,
        }
      ],
      lista: [],
      dialognuevacuota: false,
      columnasvenc: [],
      edited: {
        idcuota: 0,
        idtipocuota: 0,
        idcarrera: 0,
        anio: 0,
        nrocuota: 0,
        descripcion: '',
        idestado: 0,
        vencimientos: [],
        usuario: ''
      },
      menufvenc1: false,
      menufvenc2: false,
      /* listavencimientos: [
        {nro: 1},
        {nro: 2},
      ], */
      vencimiento: {
        fecha1: '',
        monto1: 0.00,
        fecha2: '',
        monto2: 0.00
      },
      listatiposcuota: [
        {idtipocuota: 1, nombre: 'MATRICULA ANUAL'},
        {idtipocuota: 2, nombre: 'CUOTA MENSUAL'}
      ],
      listanrocuota: [
        {nro: 1},
        {nro: 2},
        {nro: 3},
        {nro: 4},
        {nro: 5},
        {nro: 6},
        {nro: 7},
        {nro: 8},
        {nro: 9},
        {nro: 10},
        {nro: 11}
      ]
    };
  },
  mounted() {
    this.loading = true;
    this.roles=[];
    this.usuario = localStorage.getItem("user");
    var permisos = JSON.parse(localStorage.getItem("permisos"));
    var rolesuser = localStorage.getItem("rolesuserid").split(',');
    rolesuser.forEach((elemento) => {
        this.roles.push(parseInt(elemento));
    });
    var existeper = permisos.filter((p) => p.nromodulo === this.nromodulo && (this.roles.includes(p.idrol) || p.usuario === this.usuario) && p.idaccion === 1);
    if (existeper.length === 0) {
        this.loading = false;
        this.MostrarMensaje("Error","No tiene permisos para acceder a este módulo.",true);
    } else {
        this.permisolectura = permisos.filter((p) => p.nromodulo === this.nromodulo && (this.roles.includes(p.idrol) || p.usuario === this.usuario) && p.idaccion === 2).length > 0 ? true : false;
        this.permisoescritura = permisos.filter((p) => p.nromodulo === this.nromodulo && (this.roles.includes(p.idrol) || p.usuario === this.usuario) && p.idaccion === 3).length > 0 ? true : false;
        var parametro= {anio: 0};
        axios.post("inscripcioncarrera/PostCarrerasActivas", parametro, { headers: { "Content-Type": "application/json",}}).then((result) => {
          if(result.data.resultado===0){
            this.listacarreras = result.data.datos;
            this.filtros.idcarrera= this.listacarreras.length>0 ? this.listacarreras[0].idcarrera : 0;
            var i=0;
            var anioactual= (new Date()).getFullYear();
            for(i=2023;i<=anioactual+1;i++){
              this.listaanios.push({anio: i});
            }
            this.filtros.anio= anioactual;
            this.ActualizaGrilla();
          }else{
            this.loading = false;
            this.MostrarMensaje('Error', result.data.resultadomensaje, false);
          }
        }).catch((error) => {
          this.loading = false;
          this.MostrarMensaje('Error', error, false);
        });
    }
  },
  methods: {
    MostrarMensaje(titulo, cuerpo, home) {
      this.mensajetitulo = titulo;
      this.mensajecuerpo = cuerpo;
      this.mensajehome = home != null ? home : false;
      this.dialogmensaje = true;
    },
    fechaFormatoYMD(date) {
      return (date.getFullYear() + "-" + ((date.getMonth() + 1).toString().length != 2 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1) + "-" + (date.getDate().toString().length != 2 ? "0" + date.getDate() : date.getDate()));
    },
    ActualizaGrilla () {
      this.loading=true;
      var param= JSON.stringify({idcarrera: parseInt(this.filtros.idcarrera), anio: parseInt(this.filtros.anio), usuario: this.usuario });
      axios.post("administracion/PostListaCuotas", param, { headers: {"Content-Type": "application/json", }})
        .then((result) => {
          if(result.data.resultado===0){
            this.lista = result.data.datos;
            this.loading=false;
          }else{
            this.loading = false;
            this.MostrarMensaje("Error", result.data.resultadomensaje, false);
          }
      })
        .catch((error) => {
          this.loading = false;
          this.MostrarMensaje("Error", error, false);
      });
    },
    Nueva () {
      var nroc= 1;
      if(this.lista.filter(c=> c.idtipocuota===2).length>0){
        nroc = this.lista.filter(c=> c.idtipocuota===2).reduce((previous, current) => {
          return current.nrocuota > previous.nrocuota ? current : previous;
        });
      }
      this.edited= {
        idcuota: 0,
        idtipocuota: 2,
        idcarrera: this.listacarreras.length>0 ? this.filtros.idcarrera : 0,
        anio: (new Date()).getFullYear(),
        nrocuota: nroc.nrocuota<11 ? nroc.nrocuota+1 : 1,
        descripcion: '',
        idestado: 1,
        vencimientos: [],
        usuario: this.usuario
      };
      this.vencimiento= {
        fecha1: '',
        monto1: 0.00,
        fecha2: '',
        monto2: 0.00
      };
      this.dialognuevacuota= true;
    },
    Editar (item) {
      this.edited= {
        idcuota: item.idcuota,
        idtipocuota: item.idtipocuota,
        idcarrera: item.idcarrera,
        anio: item.anio,
        nrocuota: item.nrocuota,
        descripcion: item.descripcion,
        idestado: item.idestado,
        vencimientos: [],
        usuario: this.usuario
      };
      if(item.venc1ymd!=null && item.venc1ymd!=''){
        this.edited.vencimientos.push({nro: 1, fecha: item.venc1ymd, monto: parseFloat(item.monto1)});
      }
      if(item.venc2ymd!=null && item.venc2ymd!=''){
        this.edited.vencimientos.push({nro: 2, fecha: item.venc2ymd, monto: parseFloat(item.monto2)});
      }
      this.vencimiento= {
        fecha1: item.venc1ymd,
        monto1: item.monto1,
        fecha2: item.venc2ymd,
        monto2: item.monto2
      };
      this.dialognuevacuota= true;
    },
    async Anular (item) {
      if (await this.$refs.confirm.open("Confirma Anulación", "¿Esta seguro que desea anular la cuota " + item.descripcion + "?")) {
        this.loading=true;
        const cuota = JSON.stringify({idcuota: item.idcuota, usuario: this.usuario});
        axios.post("administracion/PutCuotaAnular", cuota, { headers: {"Content-Type": "application/json", }}).then((result) => {
          if(result.data.resultado===0) {
            this.ActualizaGrilla();
          }else{
            this.loading = false;
            this.MostrarMensaje("Error", result.data.resultadomensaje, false);
          }
        }).catch((error) => {
          this.loading = false;
          this.MostrarMensaje("Error", error, false);
        });
      }
    },
    GrabarCuota () {
      this.loading=true;
      this.edited.vencimientos=[];
      if(this.vencimiento.fecha1!=null && this.vencimiento.fecha1!=''){
        this.edited.vencimientos.push({nro: 1, fecha: this.vencimiento.fecha1, monto: parseFloat(this.vencimiento.monto1)});
      }
      if(this.vencimiento.fecha2!=null && this.vencimiento.fecha2!=''){
        this.edited.vencimientos.push({nro: 2, fecha: this.vencimiento.fecha2, monto: parseFloat(this.vencimiento.monto2)});
      }
      var valido=this.ValidarDatos();
      if(valido.length===0){
        const cuota = JSON.stringify(this.edited);
        axios.post("administracion/PostCuota", cuota, { headers: {"Content-Type": "application/json", }})
          .then((result) => {
            if(result.data.resultado===0) {
              this.dialognuevacuota = false;
              this.ActualizaGrilla();
            }else{
              this.loading = false;
              this.MostrarMensaje("Error", result.data.resultadomensaje, false);
            }
          }).catch((error) => {
            this.loading = false;
            this.MostrarMensaje("Error", error, false);
          });
      }else{
        this.loading=false;
        this.MostrarMensaje('Error', valido, false);
      }
    },
    ValidarDatos () {
      var valido='';
      if(this.edited.descripcion.length===0){
        valido='La cuota debe tener descripción';
      }
      if(this.vencimiento.fecha1===null || this.vencimiento.fecha1===''){
        valido='Debe ingresar fecha del primer vencimiento';
      }
      if(this.vencimiento.monto1===null || this.vencimiento.monto1===0){
        valido='Debe ingresar monto del primer vencimiento';
      }
      if(this.edited.idtipocuota===2){
        if(this.vencimiento.fecha2===null || this.vencimiento.fecha2===''){
          valido='Debe ingresar fecha del segundo vencimiento';
        }
        if(this.vencimiento.monto2===null || this.vencimiento.monto2===0){
          valido='Debe ingresar monto del segundo vencimiento';
        }
      }
      return valido;
    }
},
  computed: {
    fechalocalfvenc1: function () {
      if (this.vencimiento.fecha1 != null && this.vencimiento.fecha1 != "") {
        var fecha = new Date(this.vencimiento.fecha1);
        fecha.setDate(fecha.getDate() + 1);
        return fecha.toLocaleDateString("es-AR");
      } else {
        return "";
      }
    },
    fechalocalfvenc2: function () {
      if (this.vencimiento.fecha2 != null && this.vencimiento.fecha2 != "") {
        var fecha = new Date(this.vencimiento.fecha2);
        fecha.setDate(fecha.getDate() + 1);
        return fecha.toLocaleDateString("es-AR");
      } else {
        return "";
      }
    }
  },
};
</script>
<style>

.v-data-table > .v-data-table__wrapper > table > tbody > tr > td, .v-data-table > .v-data-table__wrapper > table > thead > tr > td, .v-data-table > .v-data-table__wrapper > table > tfoot > tr > td {
    font-size: 0.680rem !important;
    height: 25px !important;
}

.fullpantalla{
    height: 100% !important;
    width: 100% !important;
}

.letraroja {
  color: red;
}
.textocentrado {
  text-align: center;
}
.elementocentrado {
  display: flex;
  justify-content: center;
  align-items: center;
}
.col-xl,
.col-xl-auto,
.col-xl-12,
.col-xl-11,
.col-xl-10,
.col-xl-9,
.col-xl-8,
.col-xl-7,
.col-xl-6,
.col-xl-5,
.col-xl-4,
.col-xl-3,
.col-xl-2,
.col-xl-1,
.col-lg,
.col-lg-auto,
.col-lg-12,
.col-lg-11,
.col-lg-10,
.col-lg-9,
.col-lg-8,
.col-lg-7,
.col-lg-6,
.col-lg-5,
.col-lg-4,
.col-lg-3,
.col-lg-2,
.col-lg-1,
.col-md,
.col-md-auto,
.col-md-12,
.col-md-11,
.col-md-10,
.col-md-9,
.col-md-8,
.col-md-7,
.col-md-6,
.col-md-5,
.col-md-4,
.col-md-3,
.col-md-2,
.col-md-1,
.col-sm,
.col-sm-auto,
.col-sm-12,
.col-sm-11,
.col-sm-10,
.col-sm-9,
.col-sm-8,
.col-sm-7,
.col-sm-6,
.col-sm-5,
.col-sm-4,
.col-sm-3,
.col-sm-2,
.col-sm-1,
.col,
.col-auto,
.col-12,
.col-11,
.col-10,
.col-9,
.col-8,
.col-7,
.col-6,
.col-5,
.col-4,
.col-3,
.col-2,
.col-1 {
  padding: 2px !important;
}
@media only screen and (min-width: 960px) {
  .altojusto {
    height: 45px !important;
  }
}
.alineaizquierda {
  text-align: left;
}
.alineacentro {
  text-align: center;
}
.alineaderecha {
  text-align: right;
}
.ocupa30 {
  width: 30%;
}
.ocupa50 {
  width: 50%;
}
.ocupa75 {
  width: 75%;
}
.ocupa95 {
  width: 95%;
}
.centradovertical {
  vertical-align: middle;
  align-items: center;
}
.abajovertical {
  vertical-align: bottom;
}
.TituloGrilla {
  font-family: Tahoma;
  font-size: medium;
  font-weight: bold;
  background-color: darkgray;
}
.textoNegritaRojo {
  color: red !important;
  font-weight: bold !important;
}
.textoNegritaVerde {
  color: rgb(83, 248, 125) !important;
  font-weight: bold !important;
}
</style>